module.exports = __webpack_public_path__ + "img/bagaznik-rowerowy-na-hak-holowniczy.d0839350.jpg";